var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-contract-detail" },
    [
      ["add", "edit"].includes(_vm.$route.query.type)
        ? [
            _c("div", { staticClass: "header" }, [
              _c(
                "div",
                { staticClass: "steps" },
                _vm._l(_vm.stepList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      class: [
                        "step",
                        {
                          "is-finsh": _vm.step > item.id,
                          "is-process": _vm.step == item.id,
                          "is-wait": _vm.step < item.id,
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "step__head" }, [
                        _c("div", {
                          class: [
                            "line",
                            _vm.step > item.id + 1 ? "active" : "",
                          ],
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "no" }, [
                          _vm._v(_vm._s(item.id)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step__main" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "body" },
              [
                _vm._l(_vm.list, function (item, index) {
                  return item.col_isview == "是" &&
                    item.show &&
                    item.page == _vm.step
                    ? _c(
                        "div",
                        {
                          key: item.id,
                          class: ["form-group", _vm.getVerify(item)],
                        },
                        [
                          _c("div", { staticClass: "lable" }, [
                            item.require
                              ? _c("span", { staticClass: "red" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                            _vm._v(" " + _vm._s(item.name)),
                          ]),
                          _vm._v(" "),
                          item.page == 1 && _vm.$route.query.source == "prefect"
                            ? _c("div", { staticClass: "control" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.value) +
                                    "\n        "
                                ),
                              ])
                            : item.type == "文本框"
                            ? _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  staticClass: "input",
                                  attrs: { placeholder: "请输入" + item.name },
                                  domProps: { value: item.value },
                                  on: {
                                    input: function ($event) {
                                      return _vm.inputChange(
                                        "input",
                                        index,
                                        $event
                                      )
                                    },
                                    compositionstart: function ($event) {
                                      return _vm.inputChange(
                                        "compositionstart",
                                        index,
                                        $event
                                      )
                                    },
                                    compositionend: function ($event) {
                                      return _vm.inputChange(
                                        "compositionend",
                                        index,
                                        $event
                                      )
                                    },
                                    blur: _vm.inputBlur,
                                  },
                                }),
                              ])
                            : ["下拉框"].includes(item.type)
                            ? _c("div", { staticClass: "control" }, [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "select",
                                      item.value ? "" : "placeholder",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.openSelect(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.value || "请选择" + item.name)
                                    ),
                                  ]
                                ),
                              ])
                            : item.type == "日期"
                            ? _c("div", { staticClass: "control" }, [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "select",
                                      item.value ? "" : "placeholder",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDatePicker(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.value || "请选择" + item.name)
                                    ),
                                  ]
                                ),
                              ])
                            : item.type == "单选钮"
                            ? _c("div", { staticClass: "control" }, [
                                _c(
                                  "div",
                                  { staticClass: "radio-group" },
                                  _vm._l(item.default, function (radio) {
                                    return _c(
                                      "span",
                                      {
                                        key: radio,
                                        class: [
                                          "radio",
                                          item.value == radio ? "selected" : "",
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectRadio(index, radio)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(radio))]
                                    )
                                  }),
                                  0
                                ),
                              ])
                            : item.type == "多选框"
                            ? _c("div", { staticClass: "control" }, [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "select",
                                      item.value ? "" : "placeholder",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCheckBox(index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.value || "请选择"))]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.step == 4
                  ? _c("div", { staticClass: "result" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              _vm.showPreview = true
                            },
                          },
                        },
                        [_vm._v("预览合同")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn", on: { click: _vm.clearData } },
                        [_vm._v("清空数据")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn", on: { click: _vm.commitInfo } },
                        [
                          _vm.$route.query.source == "prefect"
                            ? [_vm._v("补充合同")]
                            : _vm.$route.query.source == "copy"
                            ? [_vm._v("重签合同")]
                            : _vm.$route.query.type == "edit"
                            ? [_vm._v("修改合同")]
                            : [_vm._v("提交合同")],
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _vm.step != 1
                ? _c(
                    "div",
                    {
                      staticClass: "btn btn-pre",
                      on: {
                        click: function ($event) {
                          return _vm.stepChange("pre")
                        },
                      },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step != 4
                ? _c(
                    "div",
                    {
                      staticClass: "btn btn-next",
                      on: {
                        click: function ($event) {
                          return _vm.stepChange("next")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      ["preview"].includes(_vm.$route.query.type)
        ? _c(
            "div",
            { staticClass: "body" },
            _vm._l(_vm.list, function (item, index) {
              return item.col_isview == "是" && item.show
                ? _c("div", { key: item.id, staticClass: "form-group" }, [
                    _c("div", { staticClass: "lable" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _vm._v(_vm._s(item.value || "未填写")),
                    ]),
                  ])
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPreview
        ? _c("div", { staticClass: "preview-list" }, [
            _c("div", { staticClass: "preview-title" }, [_vm._v("房源预览")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "form-group" },
              [
                _vm._l(_vm.list, function (item, index) {
                  return item.col_isview == "是" && item.show
                    ? _c("li", { key: item.id }, [
                        _c("div", { staticClass: "key" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.value || "未填写")),
                        ]),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-return",
                    on: {
                      click: function ($event) {
                        _vm.showPreview = false
                      },
                    },
                  },
                  [_vm._v("返回")]
                ),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkBox
        ? _c("div", { staticClass: "checkbox-wrapper" }, [
            _c("div", { staticClass: "checkbox-inner" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.checkBox.name)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "body" },
                _vm._l(_vm.checkBox.default, function (item) {
                  return _c(
                    "span",
                    {
                      key: item,
                      class: _vm.checkBox.values.includes(item)
                        ? "checked"
                        : "",
                      on: {
                        click: function ($event) {
                          return _vm.selectCheckBox(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-cancle",
                    on: {
                      click: function ($event) {
                        _vm.checkBox = null
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-ok", on: { click: _vm.commitCheckBox } },
                  [_vm._v("确定")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "selectDom" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }